<footer class="p-10 bg-gray-100 flex flex-col justify-center items-center">
  <h3 class="font-bold text-4xl m-2">Spotlight</h3> 
  <small class="rights m-2">An Open Source Project</small>
</footer>
